/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_MayInputs */

const he_month_may = /** @type {(inputs: Month_MayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאי`)
};

const en_month_may = /** @type {(inputs: Month_MayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May`)
};

/**
* | output |
* | --- |
* | "May" |
*
* @param {Month_MayInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_may = /** @type {((inputs?: Month_MayInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_MayInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_may(inputs)
	return en_month_may(inputs)
});